import { lineDrawingBudget } from '../../config/chartVisuals';

/**
 * The line drawing budget for a plot of the given pixel width: the number of buckets each
 * visible window is thinned to (see getRenderableLineSeriesData).
 */
export function getLineBucketCount(plotWidthPx: number): number {
  const { pixelsPerBucket, minBucketCount } = lineDrawingBudget;

  return Math.max(minBucketCount, Math.floor(Math.max(0, plotWidthPx) / pixelsPerBucket));
}
